module.exports = __webpack_public_path__ + "static/img/flow_purchase.a943087a.png";